export default __webpack_public_path__ + "static/vibrant-184311e8d941f42eb152c12a0aaec8c8.png";